import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsKeyLogService} from '../../../services/settings-key-log.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'notifications-modal',
    templateUrl: './notifications-modal.component.html',
    styleUrls: ['./notifications-modal.component.scss']
})
export class NotificationsModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    agreementText = '';
    subject = '';
    originalMessage = '';
    originalSubject = '';
    emailTemplate = null;
    placeholders = [
        '[[STAFF_MEMBER_NAME]]',
        '[[KEY_TAG]]',
        '[[BUILDING_NAME]]',
        '[[BUILDING_ADDRESS]]',
        '[[UNIT_NUMBER]]',
        '[[STATUS]]',
        '[[PURPOSE]]',
        '[[NOTE]]',
        '[[DELETED_BY]]',
        '[[DELETED_AT]]',
        '[[CHANGED_AT]]',
        '[[CHANGED_BY]]',
        '[[CREATED_AT]]',
        '[[CREATED_BY]]',
        '[[SIGNED_OUT_TO]]',
        '[[SIGNED_OUT_AT]]',
        '[[SIGNED_OUT_BY]]',
        '[[SIGNATURE]]',
        '[[SIGNED_IN_FROM]]',
        '[[SIGNED_IN_BY]]',
        '[[SIGNED_IN_AT]]',
        '[[SIGNED_IN_NOTE]]',
        '[[SIGNED_OUT_NOTE]]',
    ];
    emailTemplates = [];
    showSpinner = false;

    constructor(
        public api: ApiClientService,
        public settingsKeyLogService: SettingsKeyLogService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.getEmailTemplates();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.settingsKeyLogService.selectedItemData.staffNotificationSettings) {
            this.settingsKeyLogService.selectedItemData.staffNotificationSettings.forEach((setting) => {
                if(setting.action == this.settingsKeyLogService.bookingRequestModalNotificationType) {
                    if(!setting.emailTemplateOtherSubject && !setting.emailTemplateOtherMessage) {
                        this.emailTemplate = setting.emailTemplate;
                        this.emailTemplates.forEach((template) => {
                            if (template.id == this.emailTemplate) {
                                this.subject = template.subject;
                                this.agreementText = template.message;
                                this.originalMessage = template.message;
                                this.originalSubject = template.subject;
                            }
                        });
                    } else {
                        this.emailTemplate = 0;
                        this.subject = setting.emailTemplateOtherSubject;
                        this.agreementText = setting.emailTemplateOtherMessage;
                        this.originalMessage = setting.emailTemplateOtherMessage;
                        this.originalSubject = setting.emailTemplateOtherSubject;
                    }
                }
            });
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsKeyLogService.showNotificationsModal = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsKeyLogService.showNotificationsModal = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.emailTemplate && form.value.emailTemplate !== 0) toastr.warning('Email template should not be blank.');
            if (!form.value.subject) toastr.warning('Email subject should not be blank.');
            return;
        }
        if(!this.agreementText) {
            toastr.warning('Email text should not be blank.');
            return;
        }
        const emailTemplate = form.value.emailTemplate;

        if (!emailTemplate && emailTemplate !== 0) { toastr.warning('Email template is not set.'); return; }
        let index = -1;
        let data = {staffNotificationSettings: []};
        if(this.settingsKeyLogService.selectedItemData.staffNotificationSettings) {
            this.settingsKeyLogService.selectedItemData.staffNotificationSettings.forEach((setting) => {
                data.staffNotificationSettings.push({
                    action: setting.action,
                    emailTemplate: setting.emailTemplate
                });
            });
        }
        data.staffNotificationSettings.forEach((notification, indexInArray) => {
            if(notification.action == this.settingsKeyLogService.bookingRequestModalNotificationType)
                index = indexInArray;
        });

        if(index != -1) {
            data.staffNotificationSettings[index] = {
                action: this.settingsKeyLogService.bookingRequestModalNotificationType
            };
            if(this.emailTemplate === 0 || this.templateMessageIsModified()) {
                data.staffNotificationSettings[index].emailTemplateOtherSubject = this.subject;
                data.staffNotificationSettings[index].emailTemplateOtherMessage = this.agreementText;
            } else {
                data.staffNotificationSettings[index].emailTemplate = this.emailTemplate;
            }
        } else {
            data.staffNotificationSettings.push({
                action: this.settingsKeyLogService.bookingRequestModalNotificationType,
            });
            if(this.emailTemplate === 0) {
                data.staffNotificationSettings.forEach((notification) => {
                    if(notification.action == this.settingsKeyLogService.bookingRequestModalNotificationType) {
                        notification.emailTemplateOtherSubject = this.subject;
                        notification.emailTemplateOtherMessage = this.agreementText;
                    }
                });
            } else {
                data.staffNotificationSettings.forEach((notification) => {
                    if(notification.action == this.settingsKeyLogService.bookingRequestModalNotificationType) {
                        notification.emailTemplate = this.emailTemplate;
                    }
                });
            }
        }

        this.disabledSubmit = true;
        const url = `/v1/service_settings/${this.settingsKeyLogService.selectedItemData.id}.json`;
        this.api.patch('domainKeyLog', url, data).subscribe(
            () => {
                this.settingsKeyLogService.selectedItemData.staffNotificationSettings.forEach((notification) => {
                    if(notification.action == this.settingsKeyLogService.bookingRequestModalNotificationType) {
                        if(this.emailTemplate) {
                            notification.emailTemplate = this.emailTemplate;
                            notification.emailTemplateOtherSubject = '';
                            notification.emailTemplateOtherMessage = '';
                        } else {
                            notification.emailTemplate = null;
                            notification.emailTemplateOtherSubject = this.subject;
                            notification.emailTemplateOtherMessage = this.agreementText;
                        }
                    }
                });
                this.updateView('Email template has been updated successfully');
            },
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Email template has failed to update');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.form.reset();
        this.hideModal();
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    initSummernote(enabled) {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => {
                    this.agreementText = contents;
                    this.emailTemplate = 0;
                }
            },
            toolbar: enabled ? [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ] : [],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
                this.emailTemplate = 0;
            });
        $('.note-editable').html(this.agreementText).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });

        if(!enabled)
            summernote.summernote('disable');
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote(true), 300);
    }

    emailTemplateSelect(arr: Array<any>) {
        return arr.map(template => ({value: template.id, optionText: template.name}));
    }
    changeTemplate(event): void {
        this.emailTemplate = event;
        if(event == -1) {
            this.agreementText = '';
            document.getElementsByClassName('note-editable panel-body')[0].innerHTML = '';
        } else {
            const templateObject = this.emailTemplates.find( (template) => template.id == event);
            if(templateObject) {
                if(templateObject.id != 0) {
                    this.subject = templateObject.subject;
                    this.agreementText = templateObject.message;
                    document.getElementsByClassName('note-editable panel-body')[0].innerHTML = templateObject.message;
                } else {
                    this.subject = '';
                    this.agreementText = '';
                    document.getElementsByClassName('note-editable panel-body')[0].innerHTML = '';
                }
            }
        }
    }

    public getEmailTemplates() {
        this.showSpinner = true;
        const url = `/v1/email_template.json?per-page=1000`;
        this.api.get('domainKeyLog', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.emailTemplates = body.entities;
                this.emailTemplates.push({id: 0, name: 'Other'});
                this.initData();
                this.showSpinner = false;
                this.initSummernote(false);
            },
            error => {
                this.showSpinner = false;
                this.emailTemplates = [];
                this.emailTemplates.push({id: 0, name: 'Other'});
                this.api.errorHandler(error, 'Failed get Templates');
            }
        );
    }

    templateMessageIsModified(): boolean {
        let isModified = false;
        let originalTemplateMessage = '';
        this.emailTemplates.forEach( template => {
           if(template.id == this.emailTemplate)
               originalTemplateMessage = template.message.replace(/&nbsp;/g, '').replace(/\s/g, '').replace(/<br>/g, '');
        });
        const messageToSend = this.agreementText.replace(/&nbsp;/g, '').replace(/\s/g, '').replace(/<br>/g, '');
        if(originalTemplateMessage != messageToSend)
            isModified = true;
        return isModified;
    }

    hideEditPanelSetter() {
        this.showEditPanel = false;
        setTimeout( () => this.initSummernote(false), 300);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-email-merge/notifications-modal/notifications-modal.component.ts